import { render, staticRenderFns } from "./ContractNotificationView.vue?vue&type=template&id=afb8308a&"
import script from "./ContractNotificationView.vue?vue&type=script&lang=js&"
export * from "./ContractNotificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports